import DialogContent from '@mui/material/DialogContent';
import { styled } from '@mui/material/styles';

export const StyledDialogContent = styled(DialogContent)(() => ({
  '&.MuiDialogContent-root': {
    padding: '28px 30px',
    maxHeight: '536px',
  },
}));
